import React from 'react';
import {Trans} from 'react-i18next';
import {connect} from 'formik';
import classnames from 'classnames';
import {Link} from 'react-router-dom';

export default connect(function SimpleButtonGroup({
  formik: {isSubmitting},
  submitText,
  cancelText,
  cancelLink = '/',
  onCancelClick,
  isUpdating = false,
  isResetButton = false,
  disabled = false,
  form,
  hideSubmitButton = false,
  isNextButton = false,
  nextText,
  onNextClick,
}) {
  return (
    <>
      {isResetButton ? (
        <button
          type="reset"
          className="btn btn-outline-secondary kt-margin-r-10 kt-margin-b-10"
          disabled={isSubmitting || disabled}
        >
          {cancelText || (
            <Trans i18nKey="c.f.simple.button.group.discard">Discard</Trans>
          )}
        </button>
      ) : onCancelClick ? (
        <button
          type="button"
          className="btn btn-outline-secondary kt-margin-r-10 kt-margin-b-10"
          disabled={isSubmitting || disabled}
          onClick={onCancelClick}
        >
          {cancelText || (
            <Trans i18nKey="c.f.simple.button.group.discard">Discard</Trans>
          )}
        </button>
      ) : (
        <Link
          to={cancelLink}
          className="btn btn-outline-secondary kt-margin-r-10 kt-margin-b-10"
          disabled={isSubmitting || disabled}
        >
          {cancelText || (
            <Trans i18nKey="c.f.simple.button.group.discard">Discard</Trans>
          )}
        </Link>
      )}
      {isNextButton && (
        <button
          className="btn btn-primary kt-margin-r-10 kt-margin-b-10"
          disabled={isSubmitting || disabled}
          onClick={onNextClick}
        >
          {nextText || (
            <Trans i18nKey="c.f.simple.button.group.next">Next</Trans>
          )}
        </button>
      )}
      {!isNextButton && (
        <button
          type="submit"
          form={form && form}
          className={classnames({
            btn: true,
            'btn-primary': true,
            'kt-margin-r-10': true,
            'kt-margin-b-10': true,
            'kt-spinner': true,
            'kt-spinner-v2': true,
            'kt-spinner--center': true,
            'kt-spinner--sm': true,
            'kt-spinner--warning': isSubmitting,
            'tutorial-add-sku-add-button': true,
            'tutorial-product-grouping-products-creations': true,
            'tutorial-add-eyewear-product-save-button': true,
            'tutorial-add-lens-tint-step13': true,
          })}
          disabled={isSubmitting || disabled}
          style={{display: hideSubmitButton ? 'none' : 'inline-block'}}
        >
          <div style={{visibility: isSubmitting ? 'hidden' : 'visible'}}>
            {submitText ||
              (isUpdating ? (
                <Trans i18nKey="c.f.simple.button.group.save">Save</Trans>
              ) : (
                <Trans i18nKey="c.f.simple.button.group.add">Add</Trans>
              ))}
          </div>
        </button>
      )}
    </>
  );
});
